
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M19.188 6.753A9.686 9.686 0 0011.396.348a10.12 10.12 0 00-2.792 0A9.682 9.682 0 00.815 6.745 9.533 9.533 0 00.25 10c0 1.124.19 2.219.562 3.248A9.686 9.686 0 0010 19.75c.471 0 .94-.033 1.396-.098a9.682 9.682 0 007.789-6.397A9.533 9.533 0 0019.75 10c0-1.124-.19-2.218-.562-3.247zm-1.844-.501h-3.043a16.287 16.287 0 00-1.443-3.978 8.166 8.166 0 014.486 3.978zM18.25 10c0 .77-.111 1.524-.321 2.25h-3.353c.103-.745.174-1.496.174-2.25 0-.755-.07-1.506-.173-2.25h3.353a8.09 8.09 0 01.32 2.25zM6.938 12.25a14.873 14.873 0 01-.188-2.25c0-.753.074-1.504.188-2.25h6.125c.113.744.187 1.495.187 2.25 0 .754-.074 1.506-.188 2.25H6.938zm-4.867 0a8.11 8.11 0 01-.321-2.25c0-.77.111-1.522.321-2.25h3.353a16.413 16.413 0 00-.174 2.25c0 .755.071 1.507.174 2.25H2.071zM10.849 1.81a14.804 14.804 0 011.912 4.443H7.238A14.805 14.805 0 019.151 1.81c.28-.028.559-.06.849-.06.29 0 .569.03.849.059zm-3.708.465a16.248 16.248 0 00-1.443 3.978H2.656a8.158 8.158 0 014.485-3.978zM2.657 13.752h3.042a16.303 16.303 0 001.442 3.975 8.164 8.164 0 01-4.484-3.975zm6.494 4.44a14.83 14.83 0 01-1.912-4.44h5.522a14.835 14.835 0 01-1.911 4.44 8.612 8.612 0 01-1.699 0zm3.708-.465a16.25 16.25 0 001.442-3.975h3.042a8.161 8.161 0 01-4.484 3.975z"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/lk/img/Globe.svg